var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1649 22.5794C45.1649 10.1045 35.0574 -0.00299072 22.5824 -0.00299072C10.1075 -0.00299072 0 10.1045 0 22.5794C0 33.8506 8.25807 43.1932 19.0539 44.8887V29.1074H13.3173V22.5794H19.0539V17.604C19.0539 11.9448 22.4231 8.81873 27.5833 8.81873C30.0547 8.81873 32.6389 9.25945 32.6389 9.25945V14.814H29.7906C26.986 14.814 26.1109 16.555 26.1109 18.3407V22.5794H32.3739L31.3723 29.1074H26.1109V44.8887C36.9068 43.1932 45.1649 33.8506 45.1649 22.5794Z",
    fill: "#051C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsFacebook);
export default __webpack_public_path__ + "static/media/contactUsFacebook.305e1970f419321694edd5aeae2ccce6.svg";
export { ForwardRef as ReactComponent };